
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"18","viewBox":"0 0 16 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.6021 6.99777C11.6021 6.04252 11.2226 5.12639 10.5472 4.45093C9.87169 3.77547 8.95556 3.396 8.00031 3.396C7.04506 3.396 6.12894 3.77547 5.45348 4.45093C4.77801 5.12639 4.39854 6.04252 4.39854 6.99777C4.39854 11.1998 2.59766 12.4004 2.59766 12.4004H13.403C13.403 12.4004 11.6021 11.1998 11.6021 6.99777Z","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.03796 14.8018C8.93242 14.9837 8.78094 15.1347 8.59868 15.2397C8.41642 15.3447 8.20978 15.3999 7.99945 15.3999C7.78912 15.3999 7.58248 15.3447 7.40022 15.2397C7.21796 15.1347 7.06648 14.9837 6.96094 14.8018","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"2.5","cy":"2.5","r":"3.2","transform":"matrix(-1 0 0 1 14 1.3999)","fill":"#FF7900","stroke":"white","stroke-width":"1.4"}})])
          )
        }
      }
    